import commonUtil from '../../common/commonUtil';
import './../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css';

const jikantaiKbns = {
    "1": "昼",
    "2": "夕",
    "3": "朝"
};

export const MealInfoComf = (props) => {
    const { data } = props;
    return (
        <div>
            {data !== undefined && data.length !== 0 ?  data.map((value, index) => (
                value.foodTimeList.map((foodTime) => (
                    <div className='membership_reserve_cancel_contentarea'>
                        <div className='membership_reserve_cancel_title no_margin'/>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid str_padding'>
                                <div className='membership_reserve_cancel_subtitle block sp_label'>{value.dayCnt}日目 {jikantaiKbns[foodTime.jikantaiKbn]}食</div>
                                <div className='membership_reserve_cancel_info2'>{foodTime.restaurantCd == '88' || foodTime.restaurantCd == '89' ? '不要' : foodTime.restaurantName}</div>
                                <div className='membership_reserve_cancel_info3'/>
                            </div>
                            {foodTime.startTime &&
                                <div className='membership_reserve_cancel_wid str_padding'>
                                    <div className='membership_reserve_cancel_subtitle2'/>
                                    <div className='membership_reserve_cancel_info2'>時間</div>
                                    <div className='membership_reserve_cancel_info3'>{foodTime.startTime ? commonUtil.getTimeStr(foodTime.startTime, "hh:mm").replace(/^0+/, '') : ""}</div>
                                </div>
                            }
                            {foodTime.courseList.map((course) => (
                                <div className='membership_reserve_cancel_wid str_padding'>
                                    <div className='membership_reserve_cancel_subtitle2'/>
                                    <div className='membership_reserve_cancel_info2'>{course.foodCourseName}</div>
                                    <div className='membership_reserve_cancel_info3'>{course.targetCnt}人</div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            ))
                :
                null
            }
        </div>
    );
};